
import {
  GET_ALL_REGIONS_AND_CLASSIFY,
  SELECT_REGION,
  SELECT_REGION_CLASS
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE
} from '../../utils/status';
import * as regionService from '../../services/region';


export function select(region) {
  return {
    type: SELECT_REGION,
    data: region
  };
}


export function selectClass(zone_id) {
  return {
    type: SELECT_REGION_CLASS,
    data: zone_id
  };
}


// 获取所有地区数据，且已经分类
export function getAllRegionsAndClassify(order_id, regions) {
  return function (dispatch) {
    dispatch({
      type: GET_ALL_REGIONS_AND_CLASSIFY,
      status: PENDING
    });

    return regionService.getAllAndClassify(order_id, regions)
      .then(function (data) {
        dispatch({
          type: GET_ALL_REGIONS_AND_CLASSIFY,
          status: SUCCESS,
          data: data
        });

        let {hot_region_list, more_region_list} = data;
        let selected = hot_region_list[0];

        let zone_id = more_region_list[0].zone_id;

        // 默认选中第一个
        dispatch(select(selected));
        // 默认选中推荐
        dispatch(selectClass(zone_id));

        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_ALL_REGIONS_AND_CLASSIFY,
          status: FAILURE,
          data: err
        });

        throw err;
      });
  };
}





// WEBPACK FOOTER //
// ./src/store/actions/region.js